// Archivo: utils.js (por ejemplo, puedes tener un archivo para funciones de utilidades)
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
